import get from 'lodash.get';

const getRequestWidget = (rootState) =>
  get(rootState, 'ws.integration.settings.requestWidget', null);

export default getRequestWidget;
